module.exports = __webpack_public_path__ + "assets/images/JMDBAG10.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/JMDBAG10.png
// module id = 1391
// module chunks = 1